import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FormHeaderActionsV2 } from '@/components/custom/erp';
import type { FormDialogModel } from './hooks';
import { BasicInfoTab } from './BasicInfoTab';
import InfoDropdown from './InfoDropdown';
import { HistoryTab } from './HistoryTab';

const tabClassName =
  'relative h-8 rounded-none border-b-[3px] border-transparent bg-transparent px-4 py-1 text-[12px] font-semibold text-slate-500 shadow-none ring-0 transition-colors focus-visible:ring-0 data-[state=active]:border-b-[#023e8a] data-[state=active]:bg-[#f0f5fa] data-[state=active]:text-[#023e8a] data-[state=active]:shadow-none';

export const FormHeader = ({ dialog }: { dialog: FormDialogModel }) => (
  <Tabs value={dialog.activeTab} onValueChange={dialog.tabChange} className='w-full'>
    <div className='flex items-stretch justify-between border-b border-[#d7d7d7] bg-white'>
      <TabsList className='h-8 w-full justify-start rounded-none border-b-0 p-0 text-slate-600'>
        <TabsTrigger value='info' className={tabClassName}>
          Thông tin
        </TabsTrigger>
        {dialog.formMode === 'view' ? (
          <TabsTrigger value='history' className={tabClassName}>
            Lịch sử
          </TabsTrigger>
        ) : null}
      </TabsList>
      <FormHeaderActionsV2
        mode={dialog.formMode}
        source={{
          label: 'Đơn hàng mua trong nước',
          onClick: dialog.documents.show
        }}
        sourceClassName='-mr-1'
        info={<InfoDropdown uuid={dialog.initialData?.uuid} ma_ct={dialog.initialData?.chung_tu} />}
      />
    </div>
    <TabsContent value='info' className='mt-0 outline-none'>
      <BasicInfoTab formMode={dialog.formMode} formState={dialog.formState} />
    </TabsContent>
    {dialog.formMode === 'view' ? (
      <TabsContent value='history' className='mt-0 outline-none'>
        <HistoryTab />
      </TabsContent>
    ) : null}
  </Tabs>
);
